import { render, staticRenderFns } from "./LightCourseModuleTeaser.vue?vue&type=template&id=2297beb1&scoped=true&"
import script from "./LightCourseModuleTeaser.vue?vue&type=script&lang=js&"
export * from "./LightCourseModuleTeaser.vue?vue&type=script&lang=js&"
import style0 from "./LightCourseModuleTeaser.vue?vue&type=style&index=0&id=2297beb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2297beb1",
  null
  
)

export default component.exports